import React, { useState } from 'react';
import { Heart, X, Coffee, CreditCard, Smartphone } from 'lucide-react';
import { AnimatePresence, motion } from 'motion/react';
import { useTranslation } from 'react-i18next';

export const SupportModal: React.FC = () => {
    const { t } = useTranslation('SupportModal');
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="fixed bottom-24 md:bottom-8 right-4 md:right-8 z-50 flex flex-col items-end">
            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        initial={{ opacity: 0, y: 20, scale: 0.9 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0, y: 20, scale: 0.9 }}
                        className="bg-zinc-900 border border-skjeta-green/30 p-5 rounded-2xl shadow-2xl mb-4 w-72 md:w-80 relative"
                    >
                        <button
                            onClick={() => setIsOpen(false)}
                            className="absolute top-3 right-3 text-gray-400 hover:text-white"
                        >
                            <X size={16} />
                        </button>
                        <h3 className="text-white font-black uppercase text-sm mb-2 flex items-center gap-2">
                            <Heart size={16} className="text-red-500" /> {t('title')}
                        </h3>
                        <p className="text-gray-400 text-xs mb-4 leading-relaxed">
                            {t('description')}
                        </p>

                        <div className="space-y-3">
                            <a
                                href="https://www.buymeacoffee.com/seljen"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-full bg-[#FFDD00] hover:bg-[#FFDD00]/80 text-black font-black uppercase tracking-wider text-xs py-3 px-4 rounded-lg flex items-center gap-3 transition-transform hover:scale-[1.02] shadow-lg"
                            >
                                <Coffee size={18} /> {t('buyMeACoffee')}
                            </a>

                            <button
                                disabled
                                className="w-full bg-zinc-800 border border-white/10 text-gray-500 font-bold uppercase tracking-wider text-xs py-3 px-4 rounded-lg flex items-center gap-3 cursor-not-allowed"
                            >
                                <CreditCard size={18} /> {t('stripeComingSoon')}
                            </button>

                            <button
                                disabled
                                className="w-full bg-[#FF5B24]/10 border border-[#FF5B24]/20 text-[#FF5B24]/50 font-bold uppercase tracking-wider text-xs py-3 px-4 rounded-lg flex items-center gap-3 cursor-not-allowed"
                            >
                                <Smartphone size={18} /> {t('vippsComingSoon')}
                            </button>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>

            <button
                onClick={() => setIsOpen(!isOpen)}
                className="bg-zinc-800 border-2 border-skjeta-green text-skjeta-green hover:bg-skjeta-green hover:text-black p-3 md:p-4 rounded-full shadow-[0_0_20px_rgba(163,230,53,0.3)] transition-all flex items-center justify-center hover:scale-110"
                aria-label={t('supportUs')}
            >
                <Heart size={24} className={isOpen ? "fill-current" : ""} />
            </button>
        </div>
    );
};
